import { css, keyframes } from '@emotion/core';
import { typographyStyles } from '@newsela/angelou';

const { textS } = typographyStyles;

const fadeDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const $crosswalksContainer = css`
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid rgba(29, 29, 29, 0.16);
  animation: ${fadeDown} 0.4s ease-out forwards;
  ${textS};
`;

export const $loadingContainer = css`
  width: 100%;
  height: 30px;
`;
